import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import { SectionDescription } from "components/misc/Typography";
import { useTranslation } from "react-i18next";
import menAvatar from "images/men_avatar.svg";
import { SectionHeading } from "components/misc/Headings";
import BoardMemberMobileView from "./BoardMemberMobileView";
// Images of board members
import haraImg from "images/people/hara.jpg";
import anbeImg from "images/people/anbe.png";
import BgTitle from "components/title/BgTitle";

// Background Wrapper
const BgWrapper = styled.div`
  ${tw`fancy-feature-mask`}
`;

const Heading = tw(SectionHeading)``;

// Heading and Description
const HeadingContainer = tw.div`text-center mb-8`;
const Description = tw(SectionDescription)`mx-auto text-center text-gray-600`;

// Cards Grid
const Cards = styled.div`
  ${tw`grid gap-6 mx-auto`}
  grid-template-columns: repeat(4, 1fr); /* 4 Columns */
  max-width: 1200px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr); /* 2 Columns for tablets */
  }
  @media (max-width: 640px) {
    grid-template-columns: 1fr; /* 1 Column for mobile */
  }
`;

// Card Styling
const Card = styled.div`
  ${tw`flex flex-col items-center bg-[#eeeeee4f] rounded-lg shadow-lg p-4`}
  border: 1px solid #e2e8f0;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
`;

// Image Styling
const CardImage = styled.img`
  ${tw`rounded-full mb-4`}
  width: 150px;
  height: 150px;
  object-fit: cover;
`;

// Placeholder Icon Styling
const PlaceholderIcon = styled.div`
  ${tw`flex items-center justify-center rounded-full bg-gray-300 mb-4`}
  width: 150px;
  height: 150px;

  i {
    ${tw`text-gray-600 text-4xl`}
  }
`;

// Card Content
const CardContent = styled.div`
  ${tw`text-center`}
  .position {
    ${tw`text-sm font-semibold text-gray-700 uppercase`}
  }
  .name {
    ${tw`text-base font-bold text-gray-900 mt-1`}
  }
`;

export default ({ isXs = false }) => {
  const { t } = useTranslation();
  if(isXs) return <BoardMemberMobileView />;

  // Board members' data from translation
  const boardMembers = t("board_members", { returnObjects: true });

  // Image mapping for board members
  const images = [
    haraImg,
    anbeImg,
    "", // 岡村 貴史 - no photo
    "", // 平野 健太郎 - no photo
  ];

  return (
    <BgWrapper>
      <Container>
        <ContentWithPaddingXl>
          <HeadingContainer>
            <Heading>
              <BgTitle
                text={t("board_member_heading")}
                borderHide={true}
                isCenter={true}
              />
            </Heading>
            <Description>{t("board_member_description")}</Description>
          </HeadingContainer>

          <Cards>
            {boardMembers.map((member, index) => (
              <Card key={index}>
                {images[index] ? (
                  <CardImage
                    src={images[index] || menAvatar}
                    alt={member.name}
                  />
                ) : (
                  <PlaceholderIcon>
                    <i className="fa-solid fa-user-tie"></i>
                  </PlaceholderIcon>
                )}
                <CardContent>
                  <span className="position">{member.position}</span> <br />
                  <span className="name">{member.name}</span>
                </CardContent>
              </Card>
            ))}
          </Cards>
        </ContentWithPaddingXl>
      </Container>
    </BgWrapper>
  );
};
